<template>
  <div>
    <audio :ref="'audioPlayer-' + pluginIndex" :src="audioSrc" preload="auto" @error="playAudioError()"
      @ended="playAudioEnd()" autoplay>您的浏览器不支持 audio 元素。</audio>
    <van-cell-group>
      <van-cell v-for="(item, idx) in schema.fileList" :key="idx" :title="item.text" :value="item.rightText"
        :label="item.label" @click="onPlayMp3(idx, item)" clickable>
        <div slot="icon" class="qr-type-icon">
          <!-- <van-icon :name="item.icon" :size="schema.iconSize || 20" /> -->
          <van-icon :name="item.icon" :size="schema.iconSize || 20" />
        </div>
        <template #right-icon>
          <van-icon v-if="playIndex == idx && playIng" name="stop-circle-o" color="#ff976a" size="24" />
          <van-icon v-else name="play-circle-o" color="#07c160" size="24" />
          <!-- <span style="margin-left:5px;">
      12.4 Kb
      </span> -->
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Dialog, Toast } from 'vant';

const emptySrc = 'data:audio/mpeg;base64,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';
export default {
  name: 'mp3Play',
  props: {
    schema: {
      'type': Object,
      default: {},
      required: true
    },
    pluginIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {
    playingPluginIndex: function () {
      // 切换到其他组件播放时，这里就结束播放
      if (this.playingPluginIndex != this.pluginIndex) {
        this.onAudioReset();
        // console.log('mp3 pluginIndex onPause',this.pluginIndex)
      }

    }
  },
  computed: {
    ...mapState(['playingPluginIndex']),
  },
  data: function () {
    return {
      playIndex: null,
      playIng: false,
      audioSrc: emptySrc
    }
  },
  // mounted: function () {
  //   this.$nextTick(() => {
  //     this.init();
  //   });
  // },
  methods: {
    ...mapMutations(['setPlayingPluginIndex']),
    // is_weChat:function () {
    // 	var ua = navigator.userAgent.toLowerCase();
    // 	if (ua.match(/MicroMessenger/i) == "micromessenger") {
    // 		return true;
    // 	} else {
    // 		return false;
    // 	}
    // },
    // init:function(){
    // 	var that =this;


    // 	if(that.is_weChat()){
    // 		// 触发：尝试自动播放
    // 		document.addEventListener("WeixinJSBridgeReady", function () {
    // 			// console.log('WeixinJS')
    // 			that.onLoadAutoPlay();
    // 		});

    // 	}

    // 	that.paused() ? that.isPlaying=false : that.isPlaying=true;//否已暂停

    // },
    audioPlayer: function () {
      return this.$refs['audioPlayer-' + this.pluginIndex];
    },
    // 重置
    onAudioReset: function () {
      if (!this.playIng) {
        return;
      }
      this.onPause();//暂停
      this.playIndex = null;
      this.audioSrc = emptySrc;
    },
    //暂停
    onPause: function () {
      this.audioPlayer().pause();
      this.playIng = false;
    },
    //播放
    onPlay: function () {
      this.audioPlayer().play();//播放
      this.playIng = true;
    },
    onPlayMp3: function (idx, item) {
      // console.log('playingPluginIndex',this.playingPluginIndex)

      if (item.attach.id <= 0 || item.attach.path == "") {
        Toast.fail('未上传音频');
        return;
      }

   

      if (idx == this.playIndex) {


        if (this.audioPlayer().paused) {
          this.onPause();//暂停
          this.onPlay();//播放
          // setTimeout(function () {
          //   this.onPlay();//播放
          // }, 300)

        } else {
          this.onPause();//暂停
        }



      } else {
        // 切换自动播放
        this.playIndex = idx;
        this.audioSrc = item.attach.path;
        this.playIng = true;

        this.setPlayingPluginIndex(this.pluginIndex) //全局联动，用于停止其他组件播放

        this.onPlay();//播放
        // autoplay 失败时
        const that = this;
        setTimeout(function () {
          if (that.audioPlayer().paused) {
            that.onPlay();//播放
          }
        }, 300)
      }

      // console.log('item',item)
    },
    // 播放音频结束事件
    playAudioEnd() {
      // console.log('playAudioEnd')
      // Toast.success('已播放结束');
      this.onAudioReset(); //暂停重置
      // this.onPlay(); //重新播放
    },
    // 播放失败
    playAudioError() {
      // console.log('playAudioError')

      Dialog.alert({
        title: '提示',
        message: '播放失败，请稍后再试！',
      }).then(() => {
        // on close
      }).catch(() => { });

    },
  }
}
</script>

<style>
.qr-type-icon {
  margin-right: 8px;
  margin-top: 0px;
}
</style>